<hlm-dialog-surface size="md">
  <hlm-dialog-header>
    <hlm-dialog-icon-badge tone="primary">
      <hlm-icon name="lucideMessageSquare" size="1.1rem" />
    </hlm-dialog-icon-badge>
    <div hlmDialogHeading>
      <h2 hlmDialogTitle>Confirm mobile number</h2>
      <p hlmDialogDescription>{{ data.fullName }} · {{ data.mobile }}</p>
    </div>
    <button hlmDialogClose tabindex="-1" [disabled]="busy()" (click)="cancel()">
      <hlm-icon name="lucideX" size="1rem" />
    </button>
  </hlm-dialog-header>

  <section hlmDialogBody>
    <!-- aria-live on the stable wrapper: a screen reader announces the code and errors when they appear. -->
    <div class="flex flex-col gap-4" aria-live="polite">
      @if (phase() === 'prompt' || phase() === 'sending') {
        <p class="text-base leading-relaxed text-foreground" data-testid="confirm-mobile-prompt">
          Should we send a confirmation code via SMS to the customer?
        </p>
      }

      @if (phase() === 'code' || phase() === 'confirming') {
        <p class="text-base leading-relaxed text-foreground">
          Let the caller give you the code — compare it.
        </p>
        <div class="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-border bg-muted/40 px-6 py-5">
          <span class="break-all font-mono-feat text-4xl font-semibold tracking-[0.2em] text-foreground sm:text-5xl"
                data-testid="confirm-mobile-code">
            {{ code() }}
          </span>
          <hlm-checkbox class="min-h-11"
                        [checked]="codeMatches()"
                        (checkedChange)="codeMatches.set($event)"
                        [disabled]="phase() === 'confirming'"
                        label="is it correct?"
                        data-testid="confirm-mobile-matches" />
        </div>
      }

      @if (errorMsg(); as message) {
        <div class="flex items-start gap-2 rounded-lg border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive"
             role="alert" data-testid="confirm-mobile-error">
          <hlm-icon name="lucideTriangleAlert" size="0.9rem" class="mt-0.5 shrink-0" />
          <span>{{ message }}</span>
        </div>
      }
    </div>
  </section>

  <footer hlmDialogFooter>
    <button hlmBtn variant="outline" [disabled]="busy()" (click)="cancel()" data-testid="confirm-mobile-cancel">Cancel</button>
    @if (phase() === 'prompt' || phase() === 'sending') {
      <button hlmBtn (click)="sendCode()" [disabled]="phase() === 'sending'"
              data-testid="confirm-mobile-send">
        @if (phase() === 'sending') {
          <hlm-spinner size="16" />
          Sending...
        } @else {
          <hlm-icon name="lucideSend" size="0.9rem" />
          Send code
        }
      </button>
    } @else {
      <!-- Old CMT kept "Send confirmation code" available after a code was shown, so a lost or stale code can be re-sent. -->
      <button hlmBtn variant="outline" (click)="sendCode()" [disabled]="busy()"
              data-testid="confirm-mobile-resend">
        Send new code
      </button>
      <button hlmBtn (click)="confirm()" [disabled]="!codeMatches() || phase() === 'confirming'"
              data-testid="confirm-mobile-confirm">
        @if (phase() === 'confirming') {
          <hlm-spinner size="16" />
          Confirming...
        } @else {
          <hlm-icon name="lucideCheck" size="0.9rem" />
          Confirm code
        }
      </button>
    }
  </footer>
</hlm-dialog-surface>
